import { createSelector } from 'reselect';
import FranchiseeApi from './FranchiseeApi';

export const FRANCHISEES_NAMESPACE = 'franchisees';

export const getFranchiseesData = createSelector(
  (state) => state[FRANCHISEES_NAMESPACE],
  (franchiseesData) => {
    return franchiseesData || {};
  }
);

export const getFranchisees = createSelector(getFranchiseesData, (franchisees) => {
  return franchisees.data || [];
});

export const fetchFranchisees = {
  fetchingApiFunc: FranchiseeApi.index,
  selector: getFranchiseesData,
  paramsFromProps: () => [],
  dataNamespace: FRANCHISEES_NAMESPACE,
};
